import { css } from '@aegisjsproject/parsers/css.js';

export const layers = css`@layer reset, vendor, base, layout, components, utilities;`;
